(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["password-layout-styles"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('dialog-component').then(() => {
    const component = document.querySelector('#password-form');
    const dialog = component?.querySelector('dialog[open]');
    if (!dialog || typeof component.showDialog !== 'function') return;
    dialog.close();
    component.showDialog();
  });
  } catch(e) { console.error(e); }
})();

})();
